// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_WMS_BASE_URL,
// });

// export default axiosInstance;

import axios from "axios";
import {
  getDataInStorage,
  saveDataInStorage,
  removeDataInStorage,
} from "../utils/manageLocalStorage";
import POSTRefreshToken from "./autenticacion/POSTRefreshToken";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_WMS_BASE_URL,
});

/* ===============================
   Estado interno del interceptor
   =============================== */
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

/* ===============================
   Request interceptor
   =============================== */
axiosInstance.interceptors.request.use(
  async (config) => {
    const storedUser = await getDataInStorage("userWMS");

    if (storedUser?.token) {
      config.headers.Authorization = `${storedUser.token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ===============================
   Response interceptor
   =============================== */
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401) {
      return Promise.reject(error);
    }

    if (originalRequest._retry) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({
          resolve: (token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            resolve(axiosInstance(originalRequest));
          },
          reject,
        });
      });
    }

    isRefreshing = true;

    try {
      const storedUser = await getDataInStorage("userWMS");

      if (!storedUser?.refreshToken) {
        removeDataInStorage("userWMS");
        return Promise.reject(error);
      }

      const refreshResult = await POSTRefreshToken(storedUser.refreshToken);

      if (refreshResult?.status !== 200 || !refreshResult.data) {
        removeDataInStorage("userWMS");
        return Promise.reject(error);
      }

      const refreshedUser = refreshResult.data;
      await saveDataInStorage("userWMS", refreshedUser);

      processQueue(null, refreshedUser.token);

      originalRequest.headers.Authorization = `Bearer ${refreshedUser.token}`;
      return axiosInstance(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);
      removeDataInStorage("userWMS");
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default axiosInstance;
